/* eslint-disable */

import React, { useState } from "react";
import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import {
  fetchAuthenticationLogin,
  fetchGraphQL,
} from "../../../services/api-raindrop.js";
import NimbusTitle from "../../../ui-components/nimbus-title/nimbus-title.tsx";
import { isLocalEnvironment } from "../../../services/environment.js";
import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import { Form, useNavigate } from "react-router-dom";
import { RAINDROP_SESSION_TOKEN_KEY } from "../../../services/constants.js";
import { Size } from "../../../logic/enums.ts";

const PageHeading = () => {
  return (
    <div className="flex flex-col text-center gap-4">
      <NimbusTitle isLarge={true} />

      <p className="text-sm text-color-dark-text-secondary">
        Welcome back! Let's get you logged in. Enter your email below and we'll
        send you a magic link to get started.
      </p>
    </div>
  );
};

const FormMagicLink = ({ setHasSentMagicLink, setUrlMagicLink }) => {
  const [email, setEmail] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [errorMessage, setErrorMessage] = useState();

  const onSubmit = () => {
    setIsLoading(true);

    fetchAuthenticationLogin({
      email: email,
      application: "nimbus",
    })
      .then((data) => {
        setHasSentMagicLink(true);
        console.log(data, "RD-666");

        if (isLocalEnvironment()) {
          setUrlMagicLink(data?.url_magic_link);
        }
      })
      .catch((e) => {
        console.error(e);
        setErrorMessage(e.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  return (
    <div className="flex flex-col gap-4 w-full items-center ">
      <RaindropInput
        label={"Email"}
        value={email}
        example={"rhaz.solomon@theraindropcompany.com"}
        onChange={(e) => setEmail(e.target.value)}
        isFluid={true}
        icon={""}
        isLarge={true}
        errorMessage={errorMessage}
      />

      <RaindropButton
        title="Send Magic Link"
        onClick={onSubmit}
        size={Size.Large}
        style={ButtonStyle.Primary}
        isLoading={isLoading}
      />
    </div>
  );
};

const FormPassword = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [rawPassword, setRawPassword] = useState("");

  const [errorMessage, setErrorMessage] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = () => {
    setIsLoading(true);
    fetchGraphQL(`
          mutation {
            authenticateWithPassword(
              email: "${email}",
              password: "${rawPassword}"
              application: "nimbus"
            ) 
          }
        `)
      .then((response) => {
        if (!response?.data?.authenticateWithPassword) {
          console.log(response);
          setErrorMessage(response?.errors[0]?.message);
          setIsLoading(false);
          return;
        }
        const token = response?.data?.authenticateWithPassword;
        localStorage.setItem(RAINDROP_SESSION_TOKEN_KEY, token);
        navigate("/nimbus");
      })
      .catch((e) => {
        setErrorMessage(e.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="flex flex-col gap-4 w-full items-center ">
      <RaindropInput
        label={"Email"}
        example="rhaz.solomon@theraindropcompany.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        isFluid={true}
      />
      <RaindropInput
        label={"Password"}
        value={rawPassword}
        onChange={(e) => setRawPassword(e.target.value)}
        example="Ultimate.werewolf.123"
        isFluid={true}
        isPassword={true}
        isRevealable={true}
        errorMessage={errorMessage}
        isPopulatingExampleIfLocal={true}
      />
      <RaindropButton
        title="Login"
        onClick={onSubmit}
        size={Size.Large}
        style={ButtonStyle.Primary}
        isLoading={isLoading}
        isFluid={true}
      />
    </div>
  );
};

const NimbusLogin = () => {
  const [urlMagicLink, setUrlMagicLink] = useState();
  const [hasSentMagicLink, setHasSentMagicLink] = useState(false);

  const [useMagicForm, setUseMagicForm] = useState(false);

  const onBack = () => {
    setHasSentMagicLink(false);
  };

  if (hasSentMagicLink) {
    return (
      <div className="flex flex-col gap-4 text-color-dark-text-primary items-center justify-center">
        <div>Email sent</div>
        <RaindropButton
          title={"Back"}
          onClick={onBack}
          icon={"fa-arrow-left"}
          style={ButtonStyle.Secondary}
        />
        {isLocalEnvironment() && urlMagicLink && (
          <RaindropButton
            to={urlMagicLink}
            title="... or click here (local only)"
          />
        )}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center">
      <RaindropCard additionalClasses="gap-6 p-8 w-full max-w-xl">
        <PageHeading />

        {useMagicForm ? (
          <FormMagicLink
            setHasSentMagicLink={setHasSentMagicLink}
            setUrlMagicLink={setUrlMagicLink}
          />
        ) : (
          <FormPassword />
        )}

        <RaindropButton
          title={useMagicForm ? "Use Password" : "Use Magic Link"}
          onClick={() => setUseMagicForm(!useMagicForm)}
          style={ButtonStyle.Secondary}
        />
      </RaindropCard>
    </div>
  );
};

export default NimbusLogin;
